import React, { Component } from "react";
import { connect } from "react-redux";
import actions from "actions";

const { joinGroupFromLink } = actions;

class JoinGroup extends Component {
  constructor(props) {
    super(props);
    this.groupId = props.params.id;
  }

  componentWillMount = () => {
    this.props.joinGroup(this.groupId);
  };

  render() {
    return <main>Wait until you will be redirected...</main>;
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    joinGroup: (id) => dispatch(joinGroupFromLink(id)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(JoinGroup);



// WEBPACK FOOTER //
// ./src/containers/JoinGroup/index.jsx